<div class="emt-taxi-time-collection-wrapper">
  <div class="emt-taxi-in-title" [ngClass]="{ 'emt-taxi-in-title-condensed': isCondensedMode }">
    {{ title }}
  </div>
  @if (showTimeRangeReport && showTimeRangeReport !== undefined) {
    <section
      class="select-text-wrapper"
      [ngClass]="{ 'select-text-wrapper-condensed': isCondensedMode }"
      >
      <span class="select-text">
        Select each time range to include in the report
      </span>
    </section>
  }
  <section class="emt-taxi-time-collection-out">
    <div
      class="emt-taxi-time-collection-total"
      >
      <span class="emt-taxi-time-collection-total-label">
        {{ data.list[0]?.label }}
      </span>
      <span class="emt-taxi-time-collection-total-value">
        {{ data.list[0].value | decodeHtmlString }}
      </span>

      @if (showButton) {
        <section class="emt-taxi-time-collection-select-text-wrapper">
          <button class="report-button" type="button" (click)="handleCardClick((data?.list)[0].reportType)">
            Flights
          </button>
        </section>
      }
    </div>
    @for (taxiTime of data?.list.slice(1); track taxiTime; let i = $index) {
      <emt-taxi-time
        class="taxi-time"
        [isCondensedMode]="isCondensedMode"
        [data]="taxiTime"
        (taxiOutId)="taxiOutId($event)"
      ></emt-taxi-time>
    }
  </section>
</div>
